<template>
    <div class="Footer">
        page93 s.r.l. - c.so Piera Cillario 6-8 12051, Alba (CN) - P.IVA 01426850051<br>
        <a @click="$router.push('privacy')" class="">Privacy policy - Cookie policy</a>
    </div>
</template>

<script>
    export default {
        name: 'TopLogoBar',
        methods: {
            logoClick()
            {
                if(this.isInHome)
                {
                    this.$scrollTo("#home")
                    return;
                }

                this.$router.push('/')
            }
        }
    }
</script>

<style scoped lang="scss">
   .Footer {
       padding: 20px;
       text-align: center;
   }
</style>